import React from 'react';
import { useSelector } from 'react-redux';
import { getCurrentClubPendingMembers, getAccountAvatars } from '../../../../store/selectors';
import PendingPlayerRow from './PendingPlayerRow';

const NewMembers = () => {
  const memberList = useSelector(getCurrentClubPendingMembers);
  const avatarList = useSelector(getAccountAvatars);

  return (
    <div className={`memberList`}>
      { memberList.map(player => 
        <PendingPlayerRow 
          key={player._id} 
          player={player} 
          avatar={avatarList[player._id]} 
        />
      )}
    </div>
  );
};

export default NewMembers;